<template>
  <div
    class="model-form-viewer pointer-events-none fixed z-40 flex h-full w-full items-center justify-center"
    :class="{
      'backdrop-brightness-50': modelFormConfigs.length > 0
    }"
  >
    <div
      v-for="(modelFormConfig, i) in modelFormConfigs"
      :key="modelFormConfig.id"
      class="pointer-events-auto absolute inset-0 flex h-full w-full items-center justify-center sm:inset-[inherit]"
    >
      <ModelFormWrapper
        :model-form-config="modelFormConfig"
        :disabled="!isOnTop(i)"
        @close="isOnTop(i) ? modelFormStore.closeForm(modelFormConfig.id!) : undefined"
        @model-updated="
          (updatedModel: BaseModel) => handleModelUpdated(modelFormConfig, updatedModel)
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ModelFormWrapper from "@/components/crud/ModelFormWrapper.vue"
import { useModelFormStore } from "@/store/model-forms.store"
import { storeToRefs } from "pinia"
import type { BaseModel } from "@/models/base.model.ts"

const modelFormStore = useModelFormStore()
const { modelFormConfigs } = storeToRefs(modelFormStore)

function isOnTop(i: number) {
  return i === modelFormConfigs.value.length - 1
}

function handleModelUpdated(modelFormConfig: any, updatedModel: any) {
  // Update the model in the form config
  Object.assign(modelFormConfig.model, updatedModel)
}
</script>

<style scoped></style>
